export default __webpack_public_path__ + "static/media/LOGO_1.b45259e3.svg";